import React from "react";

interface ErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry?: () => void;
  title?: string;
  message: string;
  error?: string;
  details?: string;
  showRetry?: boolean;
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
  isOpen,
  onClose,
  onRetry,
  title = "Error",
  message,
  error,
  details,
  showRetry = false,
}) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="error-dialog" onClick={handleBackdropClick}>
      <div className="error-dialog-content">
        <button
          className="close-modal"
          onClick={handleClose}
          aria-label="Close error dialog"
        >
          &times;
        </button>

        <div className="error-icon">✗</div>

        <h2 className="error-title">{title}</h2>
        <p className="error-message">{message}</p>

        {details && (
          <div className="error-details">
            <h3 className="error-subtitle">Additional Information</h3>
            <p className="error-text">{details}</p>
          </div>
        )}

        <div className="error-actions">
          {showRetry && onRetry && (
            <button className="error-btn-primary" onClick={onRetry}>
              Try Again
            </button>
          )}
          <button className="error-btn-secondary" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
